<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('plans.new.back') }}</router-link>
        <div class="admin-card edit-card">
            <div class="admin-section-label">
                <i class="bi bi-plus-square"></i>
                {{ $t('plans.new.title') }}
            </div>
            <form action="" method="post" @submit.prevent="createPlan">
                <div class="form-grid">
                    <div class="form-row">
                        <label for="title" class="form-label">{{ $t('plans.new.form.title') }}</label>
                        <input type="text" class="form-control" placeholder="free" v-model="title" name="planTitle" required>
                    </div>
                    <div class="form-row">
                        <label for="price" class="form-label">{{ $t('plans.new.form.price') }}</label>
                        <input type="number" class="form-control" placeholder="₸" name="price" v-model="price" required>
                    </div>
                    <div class="form-row">
                        <label for="cycle" class="form-label">{{ $t('plans.new.form.cycle') }}</label>
                        <select class="form-select" :aria-label="$t('plans.new.form.cyclePeriodAria')" name="cycle" v-model="cycle" id="cycle" required>
                            <option v-for="option in cycles" :value="option.value" :selected="option.selected" :key="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-actions">
                    <button type="submit" class="btn-purple">
                        <i class="bi bi-arrow-right"></i>
                        <span>{{ $t('plans.new.next') }}</span>
                    </button>
                    <button type="button" class="btn-ghost" @click="$router.go(-1)">{{ $t('plans.new.cancel') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { cycles } from '../../../lib/utils'
import Function from './Function.vue'

export default {
    data: () => ({
        title: '',
        price: '',
        cycle: '2',
        created: '',
        expiry: '',
        cycles: cycles
    }),
    components: {
        Function
    },
    async mounted() {
        this.$emit('setPageTitle', this.$t('plans.new.title'))

        this.setDates()
    },
    methods: {
        setDates() {
            let now = new Date()
            this.created = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2)

            let ts = now.getTime() / 1000
            let nextYear = new Date((ts + 31536000) * 1000)
            this.expiry = nextYear.getFullYear() + '-' + ('0' + (nextYear.getMonth() + 1)).slice(-2) + '-' + ('0' + nextYear.getDate()).slice(-2)
        },
        async createPlan() {
            let data = {
                title: this.title,
                price: this.price,
                cycle: this.cycle,
                created: this.created,
                expiry: this.expiry
            }
            let response = await this.$api.createPlan(data)

            if(response.result === 'SUCCESS') {
                let id = response.data
                this.$router.push(`/plans/${id}/modules`)
            }
        },
        onlyLetters(str) {
            if (!str) return ''
            return str.replace(/[^a-zA-Zа-яА-Я]/g, '')
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 600px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 160px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
}
</style>
